import {JColors} from 'themes/colors';

export default {
  container: {
    backgroundColor: 'transparent',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-around',
  },
  circleChart: {
    display: 'flex',
    flex: 1,
  },
  totalText: {
    fontFamily: 'AvenirNext',
    fontSize: '12px',
    fontWeight: '500',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 'normal',
    letterSpacing: '-0.06px',
    textAlign: 'center',
    color: '#9b9b9b',
  },
  totalShipment: {
    fontSize: '14px',
    textAlign: 'center',
  },
  totalCompleted: {
    fontSize: '14px',
    marginBottom: '25px',
    textAlign: 'center',
  },
};
